<template>
  <div class="footer-container--minisite">
    <div class="row">
      <div class="subscriptn_offers">
        <h3>Subscribe and get...</h3>
        <ul class="subthis">
          <li><img alt="Safe and secure ordering" src="https://assets.magazine.co.uk/skin/frontend/rwd/magazine-gulp/images/subscr_mag_001.png" /></li>
          <li><img alt="Free Delivery" src="https://assets.magazine.co.uk/skin/frontend/rwd/magazine-gulp/images/subscr_mag_002.png" /></li>
          <li><img alt="Huge savings" src="https://assets.magazine.co.uk/skin/frontend/rwd/magazine-gulp/images/subscr_mag_003.png" /></li>
          <li><img alt="Protection from price rises" src="https://assets.magazine.co.uk/skin/frontend/rwd/magazine-gulp/images/subscr_mag_004.png" /></li>
          <li><img alt="No VAT on price subscriptions" src="https://assets.magazine.co.uk/skin/frontend/rwd/magazine-gulp/images/subscr_mag_005.png" /></li>
          <li><img alt="Create your own e-card" src="https://assets.magazine.co.uk/skin/frontend/rwd/magazine-gulp/images/subscr_mag_006.png" /></li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MinisiteFooter',
  serverCacheKey() {
    return 'MinisiteFooter'
  }
}
</script>
<style lang="scss">
.footer-container--minisite {
  max-width: 1230px;
  margin: auto;
  padding-left: 15px;
  padding-right: 15px;
}
@media (min-width: 992px) {
  h3 {
    font-size: 16.38px;
  }
  .subscriptn_offers {
    margin: 20px auto;
    padding: 10px;
    height: 100%;
    min-height: 100%;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    background-color: #ccc;
    max-width: 90%;
    text-align: center;
    width: 100%;
  }
}
</style>
